'use client';

import { useSearchContext } from '@/src/services/search/SearchProvider';
import { TranscendOverride } from '@nxt-costco-com/forge-digital-components';

export const TranscendOverrideWrapper = () => {
    const { searchResult } = useSearchContext();
    const executeTranscendOverrideScript =
        searchResult?.isAdTargetingEnabled === false;

    if (!executeTranscendOverrideScript) {
        return null;
    }

    return <TranscendOverride />;
};
